import { render, staticRenderFns } from "./VuetableComponent.vue?vue&type=template&id=e39ff492"
import script from "./VuetableComponent.vue?vue&type=script&lang=js"
export * from "./VuetableComponent.vue?vue&type=script&lang=js"
import style0 from "./VuetableComponent.vue?vue&type=style&index=0&id=e39ff492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports